export type AnswerHTML = {
  text: string | null
  link: {
    href?: string | null
    text?: string | null
  }
  html?: string | null
}

export function textToHtmlElements(paragraphHtml: string): AnswerHTML {
  const wrapper = document.createElement('div')
  wrapper.innerHTML = paragraphHtml

  const paragraphText = wrapper.textContent
  const a = wrapper.getElementsByTagName('a')

  const __html = wrapper.getElementsByTagName('img')

  return {
    text: `${paragraphText}`,
    link: {
      href: a.item(0)?.getAttribute('href'),
      text: a.item(0)?.textContent,
    },
    html: __html.length > 0 ? paragraphHtml : undefined,
  }
}
